// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"973a8187","239":"c4dc5687","732":"5ca50b70"}[chunkId] + ".chunk.js";
};